<template>
    <div>
        <div class="block-content bg-body-light">
            <form @submit.prevent="sendEmail">
                <div class="form-group row">
                    <div class="col-md-4">
                        <div class="">
                            <label>Emal of receipient</label>
                            <input
                                type="email"
                                class="form-control"
                                v-model="form.email"
                            />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="">
                            <label>Name of receipient</label>
                            <input
                                type="tet"
                                class="form-control"
                                v-model="form.name"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-8">
                        <div class="">
                            <label for="material-text2">Subject</label>
                            <input
                                type="text"
                                class="form-control"
                                required
                                id="material-text2"
                                v-model="form.subject"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-8">
                        <div class="">
                            <label for="material-textarea-large2"
                                >Body (exclude greeting and end)</label
                            >
                            <textarea
                                class="form-control"
                                required
                                id="material-textarea-large"
                                v-model="form.body"
                                rows="8"
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div v-if="processing" class="col-6 col-md-3">
                        <i class="fa fa-2x fa-cog fa-spin text-primary"></i>
                    </div>
                    <div class="col-md-9" v-else>
                        <button type="submit" class="btn btn-alt-primary">
                            Send
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "../../repository/RepositoryFactory";

const UsersRepository = RepositoryFactory.get("users");
export default {
    data() {
        return {
            processing: false,
            form: new Form({
                id: "",
                subject: "",
                body: "",
                email: "",
                name: "",
            })
        };
    },
    methods: {
        sendEmail() {
            this.processing = true;
            let data = {
                subject: this.form.subject,
                body: this.form.body,
                email: this.form.email,
                name: this.form.name,
            };
            UsersRepository.sendEmails(data)
                .then(response => {
                    toast.fire({
                        type: "success",
                        title: "Email sent successfully"
                    });
                    this.processing = false;
                })
                .catch(error => {
                    if (error.response.status == 403) {
                        toast.fire({
                            type: "error",
                            title: "Action Unauthorized"
                        });
                        this.processing = false;
                    } else
                        toast.fire({
                            type: "error",
                            title: "Error!. Failed to send email"
                        });
                    this.processing = false;
                });
        }
    }
};
</script>

<style scoped></style>
